export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";